import { FESTIVALS } from "../../data/content";

const FEST_IMG =
    "https://images.unsplash.com/photo-1634918221993-384376dc8c49?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxuYWdhJTIwdHJpYmVzJTIwaG9ybmJpbGwlMjBmZXN0aXZhbHxlbnwwfHx8fDE3NzgzOTU5NDZ8MA&ixlib=rb-4.1.0&q=85";

export const Festivals = () => {
    return (
        <section
            id="festivals"
            data-testid="festivals-section"
            className="relative bg-paper py-28 md:py-40"
        >
            <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-14 grid grid-cols-12 gap-8 lg:gap-14">
                <div className="col-span-12 lg:col-span-5 reveal">
                    <p className="text-xs uppercase tracking-[0.28em] text-terracotta mb-6">
                        — Festivals & seasons
                    </p>
                    <h2 className="font-serif text-forest text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-light">
                        Plan around <em className="italic text-terracotta">a fire</em>,
                        not a date.
                    </h2>
                    <p className="mt-8 text-slatewarm text-base md:text-[17px] leading-relaxed max-w-md">
                        The Northeast keeps a calendar of its own — drumbeats, harvest, blossoms,
                        butter lamps. Pick your moment and we'll build the rest of the journey
                        around it.
                    </p>

                    <div className="mt-10 relative h-[360px] md:h-[420px] overflow-hidden">
                        <img
                            src={FEST_IMG}
                            alt="Hornbill festival in Nagaland"
                            className="absolute inset-0 h-full w-full object-cover"
                            loading="lazy"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-forest/70 via-forest/10 to-transparent" />
                        <div className="absolute bottom-6 left-6 right-6 text-paper">
                            <p className="font-serif italic text-2xl md:text-3xl leading-snug">
                                "Sixteen tribes, one fire."
                            </p>
                            <p className="mt-2 text-[11px] uppercase tracking-[0.28em] text-marigold">
                                Hornbill · Kisama · December
                            </p>
                        </div>
                    </div>
                </div>

                <div className="col-span-12 lg:col-span-7 reveal">
                    <ul className="divide-y divide-forest/15">
                        {FESTIVALS.map((f, i) => (
                            <li
                                key={f.name}
                                data-testid={`festival-${i}`}
                                className="grid grid-cols-12 gap-4 py-7 md:py-9 group hover:bg-stone/60 transition-colors -mx-4 px-4"
                            >
                                <div className="col-span-1 font-serif italic text-terracotta text-xl md:text-2xl">
                                    {String(i + 1).padStart(2, "0")}
                                </div>
                                <div className="col-span-11 md:col-span-5">
                                    <h3 className="font-serif text-forest text-2xl md:text-3xl font-light leading-tight">
                                        {f.name}
                                    </h3>
                                    <p className="mt-1 text-slatewarm text-sm md:text-base">
                                        {f.where}
                                    </p>
                                </div>
                                <div className="col-span-12 md:col-span-3 text-slatewarm text-xs md:text-sm uppercase tracking-[0.2em] flex md:items-center">
                                    {f.when}
                                </div>
                                <div className="col-span-12 md:col-span-3 font-serif italic text-forest/70 text-base md:text-lg leading-snug flex md:items-center">
                                    {f.note}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </section>
    );
};
